import React, { useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	DialogActions,
	Button,
	Stack,
	FormHelperText,
} from '@mui/material';
import { AI_WORKFLOW_TYPES } from '@/features/aiWorkflow/constants';
import FolioCheckbox from '@/components/FolioCheckbox';
import { useSelector } from 'react-redux';
import { AI_DISCLAIMER } from '@/utils/constants';

const ConfirmGenerateAIDialog = ({
	workflowType,
	confirmationOpen,
	setConfirmationOpen,
	onConfirm,
	onClose,
}) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const [emailUser, setEmailUser] = useState(false);

	const title = AI_WORKFLOW_TYPES[workflowType];

	const handleClose = () => {
		setEmailUser(false);
		setConfirmationOpen(false);
		onClose?.();
	};

	return (
		<Dialog open={confirmationOpen} onClose={handleClose} maxWidth='xs' fullWidth={true}>
			<DialogTitle>{`Generate ${title}`}</DialogTitle>
			<DialogContent>
				<Stack spacing={2}>
					<Typography>
						<span>{'This will start the workflow for generating a '}</span>
						<span style={{ fontWeight: 'bold' }}>{title}</span>
						<span>
							{' based on the risk info and/or quote documents you have uploaded.'}
						</span>
					</Typography>
					<FormHelperText sx={{ ml: 0 }}>{AI_DISCLAIMER}</FormHelperText>
					<FolioCheckbox
						checked={emailUser}
						label={'I would like to receive an email once the workflow has finished'}
						onChange={() => setEmailUser((prev) => !prev)}
					/>
					{emailUser && (
						<Typography>
							{`An email will be sent to your email address (${email}).`}
						</Typography>
					)}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color='primary'>
					Cancel
				</Button>
				<Button
					onClick={() => {
						onConfirm(emailUser);
						handleClose();
					}}
					color='primary'
					variant='contained'
				>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmGenerateAIDialog;
